export default __webpack_public_path__ + "static/reauthenticateDemo-151052d3c78271c83538d286f253a8a8.gif";